export default class Count {
  public count = 1;
}
